module.exports = __webpack_public_path__ + "img/beauty_bg-en.21ae3222.webp";